import React, { useState } from 'react';

import './DateDropdown.scss';
import { buildDateString } from '../../helpers/date';
import icons from '../../shared/assets/icons/redesign';

const { ChevronDown } = icons;

const months = {
  januari: 31,
  februari: 28,
  maart: 31,
  april: 30,
  mei: 31,
  juni: 30,
  juli: 31,
  augustus: 31,
  september: 30,
  oktober: 31,
  november: 30,
  december: 31
};

const years = [];

const leapYears = [
  2032, 2028, 2024, 2020, 2016, 2012, 2008, 2004, 2000, 1996, 1992, 1988, 1984,
  1980, 1976, 1972
];

for (let year = 1970; year <= new Date().getFullYear(); year++)
  years.push(year);

export default function DateDropdown({ onChange, reference }) {
  const [date, setDate] = useState({});

  return (
    <div
      className="dateDropdown"
      data-value={format(date)}
      {...(reference && { ref: reference })}
    >
      <div className="dateDropdown-select-wrap">
        <select
          name="month"
          defaultValue=""
          className="dateDropdown-select"
          required
          onChange={(e) => (
            setDate({ ...date, month: e.target.value }), onChange()
          )}
        >
          <option value="" disabled>
            Maand
          </option>
          {Object.keys(months).map((month) => (
            <option key={month} value={month}>
              {month.charAt(0).toUpperCase() + month.slice(1)}
            </option>
          ))}
        </select>

        <ChevronDown className="dateDropdown-select-icon" />
      </div>

      <div className="dateDropdown-select-wrap">
        <select
          name="day"
          defaultValue=""
          className="dateDropdown-select"
          required
          onChange={(e) => (
            setDate({ ...date, day: e.target.value }), onChange()
          )}
        >
          <option value="" disabled>
            Dag
          </option>
          {date.month &&
            Array.from({ length: getDays(date.month, date.year) }).map(
              (item, idx) => (
                <option key={idx} value={idx + 1}>
                  {idx + 1}
                </option>
              )
            )}
        </select>

        <ChevronDown className="dateDropdown-select-icon" />
      </div>

      <div className="dateDropdown-select-wrap">
        <select
          defaultValue=""
          name="year"
          className="dateDropdown-select"
          required
          onChange={(e) => (
            setDate({ ...date, year: e.target.value }), onChange()
          )}
        >
          <option value="" disabled>
            Jaar
          </option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <ChevronDown className="dateDropdown-select-icon" />
      </div>
    </div>
  );
}

function getDays(month, year) {
  if (year && month === 'februari' && leapYears.includes(+year)) return 29;

  return months[month];
}

function format(date) {
  if (!date.year || !date.month || !date.day) return;

  const month = Object.keys(months).findIndex((month) => month === date.month);

  return buildDateString(new Date(date.year, month, date.day));
}
